import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_DATASET_LANG: {
  RESET_TARGET_DATASETS_DESCRIPTION: MvnCodeFE;
  RESET_TARGET_DATASETS_SUCCEED: MvnCodeFE;
  RESET_TARGET_DATASETS_FAIL: MvnCodeFE;
  CREATE_CANDIDATE_DATASET_SUCCEED: MvnCodeFE;
  CREATE_CANDIDATE_DATASET_FAIL: MvnCodeFE;
  DELETE_CANDIDATE_DATASET_SUCCEED: MvnCodeFE;
  DELETE_CANDIDATE_DATASET_FAIL: MvnCodeFE;
  CREATE_CANDIDATE_SUPP_DATASET_SUCCEED: MvnCodeFE;
  CREATE_CANDIDATE_SUPP_DATASET_FAIL: MvnCodeFE;
  CREATE_TARGET_DATASET_SUCCEED: MvnCodeFE;
  CREATE_TARGET_DATASET_FAIL: MvnCodeFE;
  CREATE_USER_DEFINED_DOMAIN_SUCCEED: MvnCodeFE;
  CREATE_USER_DEFINED_DOMAIN_FAIL: MvnCodeFE;
  DELETE_TARGET_DATASET_DESCRIPTION: MvnCodeFE;
  DELETE_TARGET_DATASET_SUCCEED: MvnCodeFE;
  DELETE_TARGET_DATASET_FAIL: MvnCodeFE;
  VARIABLE_REORDERING_TOAST_SUCCEED: MvnCodeFE;
  VARIABLE_REORDERING_TOAST_FAIL: MvnCodeFE;
  CREATE_CUSTOM_DOMAIN_DATASET_TITLE: MvnCodeFE;
  CREATE_TARGET_DATASET_TITLE: MvnCodeFE;
  CANDIDATE_DATASETS_TITLE: MvnCodeFE;
  TARGET_DATASETS_TITLE: MvnCodeFE;
  REORDERING_ACTIVE_TITLE: MvnCodeFE;
  REORDERING_INACTIVE_TITLE: MvnCodeFE;
  KEY_REORDERING_TITLE: MvnCodeFE;
  KEY_REORDERING_DIALOG_TITLE: MvnCodeFE;
  KEY_REORDERING_DIALOG_DESCRIPTION: MvnCodeFE;
  KEY_RESET_TITLE: MvnCodeFE;
  ADD_VARIABLE_TITLE: MvnCodeFE;
  ADD_VARIABLE_TITLE_DESCRIPTION: MvnCodeFE;
  KEY_REORDERING_TOAST_SUCCEED: MvnCodeFE;
  KEY_REORDERING_TOAST_FAIL: MvnCodeFE;
  KEY_RESET_TOAST_SUCCEED: MvnCodeFE;
  KEY_RESET_TOAST_FAIL: MvnCodeFE;
  CREATE_TARGET_VARIABLE_KEY_SUCCEED: MvnCodeFE;
  CREATE_TARGET_VARIABLE_KEY_FAIL: MvnCodeFE;
  DELETE_TARGET_VARIABLE_KEY_SUCCEED: MvnCodeFE;
  DELETE_TARGET_VARIABLE_KEY_FAIL: MvnCodeFE;
  DELETE_TARGET_VARIABLE_DESCRIPTION: MvnCodeFE;
  DELETE_TARGET_VARIABLES_DESCRIPTION: MvnCodeFE;
  DELETE_TARGET_VARIABLE_SUCCEED: MvnCodeFE;
  DELETE_TARGET_VARIABLE_FAIL: MvnCodeFE;
  CREATE_TARGET_VARIABLE_SUCCEED: MvnCodeFE;
  CREATE_TARGET_VARIABLE_FAIL: MvnCodeFE;
  PLACEHOLDER_DOMAIN_NAME: MvnCodeFE;
  PLACEHOLDER_DOMAIN_LABEL: MvnCodeFE;
  PLACEHOLDER_STRUCTURE: MvnCodeFE;
  PLACEHOLDER_DATASET_NAME: MvnCodeFE;
  PLACEHOLDER_DATASET_LABEL: MvnCodeFE;
  DATASET_REMOVE_RESTRICT_DESCRIPTION: MvnCodeFE;
  DATASET_REMOVE_RESTRICT_CANDIDATE_IN_USE: MvnCodeFE;
  DATASET_REMOVE_RESTRICT_PREDECESSOR_IN_USE: MvnCodeFE;
  EXPORT_TARGET_DATASETS_TITLE: MvnCodeFE;
  EXPORT_TARGET_DATASETS_DESCRIPTION: MvnCodeFE;
  CUSTOM_DOMAIN_NAME_RULE_EXCEEED: MvnCodeFE;
  DATASET_NAME_RULE_EXCEEED: MvnCodeFE;
  DATASET_FIELD_MAX_LENGTH_EXCEEDED: MvnCodeFE;
  SELECTION_BAR_SELECT_ALL_BUTTON: MvnCodeFE;
  SELECTION_BAR_UNCHECK_BUTTON: MvnCodeFE;
  TARGET_VARIABLES_TITLE: MvnCodeFE;
  INDEXED_VARIABLE_CREATE_DIALOG_TITLE: MvnCodeFE;
  INDEXED_VARIABLE_RESET_DIALOG_TITLE: MvnCodeFE;
  INDEXED_VARIABLE_CREATE_DIALOG_DESCRIPTION: MvnCodeFE;
  INDEXED_VARIABLE_RESET_DIALOG_DESCRIPTION: MvnCodeFE;
  INDEXED_VARIABLE_MAX_INDEX_LABEL: MvnCodeFE;
  INDEXED_VARIABLE_MAX_INDEX_PLACEHOLDER: MvnCodeFE;
  INDEXED_VARIABLE_GENERATE_BUTTON: MvnCodeFE;
  INDEXED_VARIABLE_REGENERATE_BUTTON: MvnCodeFE;
  INDEXED_VARIABLE_UPSERT_SUCCEED: MvnCodeFE;
  INDEXED_VARIABLE_UPSERT_FAIL: MvnCodeFE;
  INDEXED_VARIABLE_RESET_SUCCEED: MvnCodeFE;
  INDEXED_VARIABLE_RESET_FAIL: MvnCodeFE;
  INDEXED_VARIABLE_POSITIVE_INTEGER_VALIDATION: MvnCodeFE;
  INDEXED_VARIABLE_MAX_EXCEEDED_VALIDATION: MvnCodeFE;
} = {
  RESET_TARGET_DATASETS_DESCRIPTION: {
    ko: "현재 구성된 모든 설정이 삭제되고 초기화 됩니다.\n초기화를 진행하시겠습니까?",
    en: "All currently configured settings will be deleted and reset to their default values.\nDo you wish to proceed with the reset?",
  },
  RESET_TARGET_DATASETS_SUCCEED: {
    ko: "초기화를 완료했습니다.",
    en: "Initialization has been completed.",
  },
  RESET_TARGET_DATASETS_FAIL: {
    ko: "초기화에 실패했습니다.",
    en: "Failed to initialize.",
  },
  CREATE_CANDIDATE_DATASET_SUCCEED: {
    ko: "도메인 & 데이터 세트 생성을 완료했습니다.",
    en: "Custom Domain & Dataset creation has been completed.",
  },
  CREATE_CANDIDATE_DATASET_FAIL: {
    ko: "도메인 & 데이터 세트 생성에 실패했습니다.",
    en: "Failed to create the Custom Domain & Dataset.",
  },
  DELETE_CANDIDATE_DATASET_SUCCEED: {
    ko: "도메인 & 데이터 세트를 삭제했습니다.",
    en: "The domain and dataset have been deleted.",
  },
  DELETE_CANDIDATE_DATASET_FAIL: {
    ko: "도메인 & 데이터 세트 삭제에 실패했습니다.",
    en: "Failed to delete the domain and dataset.",
  },
  CREATE_CANDIDATE_SUPP_DATASET_SUCCEED: {
    ko: "{name} 가(이) 추가 되었습니다.",
    en: "The {name} has been added.",
  },
  CREATE_CANDIDATE_SUPP_DATASET_FAIL: {
    ko: "도메인 & 데이터 세트 생성에 실패했습니다.",
    en: "Failed to add {name}",
  },
  CREATE_TARGET_DATASET_SUCCEED: {
    ko: "{name} 을(를) 대상 데이터 세트로 추가했습니다.",
    en: "{name} has been added as the target dataset.",
  },
  CREATE_TARGET_DATASET_FAIL: {
    ko: "대상 데이터 세트 추가에 실패했습니다.",
    en: "Failed to add the target dataset.",
  },
  CREATE_USER_DEFINED_DOMAIN_SUCCEED: {
    ko: "Dataset({name})을 생성하였습니다.",
    en: "Dataset({name}) has been created.",
  },
  CREATE_USER_DEFINED_DOMAIN_FAIL: {
    ko: "Dataset({name}) 생성에 실패하였습니다.",
    en: "Failed to create Dataset({name}).",
  },
  DELETE_TARGET_DATASET_DESCRIPTION: {
    ko: "{name} 을(를) 삭제하겠습니까?",
    en: "Are you sure you want to delete {name}?",
  },
  DELETE_TARGET_DATASET_SUCCEED: {
    ko: "대상 데이터 세트를 삭제했습니다.",
    en: "The target dataset has been deleted.",
  },
  DELETE_TARGET_DATASET_FAIL: {
    ko: "대상 데이터 세트 삭제에 실패했습니다.",
    en: "Failed to delete the target dataset.",
  },

  REORDERING_ACTIVE_TITLE: { ko: "순서 변경", en: "Reordering" },
  REORDERING_INACTIVE_TITLE: { ko: "순서 변경 종료", en: "Exit Reordering" },
  KEY_REORDERING_TITLE: { ko: "키 변수 순서 조정", en: "Reordering" },
  KEY_REORDERING_DIALOG_TITLE: { ko: "키 변수 순서 조정", en: "Key variable reordering" },
  KEY_REORDERING_DIALOG_DESCRIPTION: {
    ko: "키 변수 순서를 변경할 수 있습니다.",
    en: "It is possible to change the order of the key variables.",
  },
  KEY_RESET_TITLE: { ko: "키 초기화", en: "Reset" },
  CREATE_CUSTOM_DOMAIN_DATASET_TITLE: { ko: "사용자 생성 도메인 & 데이터 세트 추가", en: "Add Custom Domain & Dataset" },
  CANDIDATE_DATASETS_TITLE: { ko: "후보 데이터 세트", en: "Candidate Datasets" },
  TARGET_DATASETS_TITLE: { ko: "대상 데이터 세트", en: "Target Datasets" },

  CREATE_TARGET_DATASET_TITLE: { ko: "대상 데이터 세트에 추가", en: "Add to Target Datasets" },

  ADD_VARIABLE_TITLE: { ko: "변수 추가", en: "Add Variable(s)" },
  ADD_VARIABLE_TITLE_DESCRIPTION: {
    ko: "추가할 변수를 체크해 주세요.",
    en: "Select the variable you wish to add.",
  },
  VARIABLE_REORDERING_TOAST_SUCCEED: {
    ko: "변수의 순서 적용을 완료했습니다.",
    en: "Variable order application has been completed.",
  },
  VARIABLE_REORDERING_TOAST_FAIL: {
    ko: "변수의 순서 적용에 실패했습니다.",
    en: "Failed to apply variable order.",
  },
  KEY_REORDERING_TOAST_SUCCEED: {
    ko: "키 변수의 순서 적용을 완료했습니다.",
    en: "Key order application has been completed.",
  },
  KEY_REORDERING_TOAST_FAIL: {
    ko: "키 변수의 순서 적용에 실패했습니다.",
    en: "Failed to apply key order.",
  },

  KEY_RESET_TOAST_SUCCEED: {
    ko: "키 초기화를 완료했습니다.",
    en: "The key has been initialized.",
  },
  KEY_RESET_TOAST_FAIL: {
    ko: "키 초기화에 실패했습니다.",
    en: "Failed to initialize the key.",
  },

  CREATE_TARGET_VARIABLE_KEY_SUCCEED: {
    ko: "{name}을(를) 키 변수로 추가하였습니다.",
    en: "{name}을(를) 키 변수로 추가하였습니다.", // TODO : 영문 번역 필요
  },
  CREATE_TARGET_VARIABLE_KEY_FAIL: {
    ko: "키 변수 추가에 실패 하였습니다.",
    en: "키 변수 추가에 실패 하였습니다.", // TODO : 영문 번역 필요
  },
  DELETE_TARGET_VARIABLE_KEY_SUCCEED: {
    ko: "{name}을(를) 키 변수에서 제거하였습니다.",
    en: "{name}을(를) 키 변수에서 제거하였습니다.", // TODO : 영문 번역 필요
  },
  DELETE_TARGET_VARIABLE_KEY_FAIL: {
    ko: "키 변수 제거에 실패 하였습니다.",
    en: "키 변수 제거에 실패 하였습니다.", // TODO : 영문 번역 필요
  },
  DELETE_TARGET_VARIABLE_DESCRIPTION: {
    ko: "{name}을(를) 삭제하겠습니까?",
    en: "Would you like to confirm the deletion of {name}?",
  },
  DELETE_TARGET_VARIABLES_DESCRIPTION: {
    ko: "{name}외 {count}개를 삭제하겠습니까?",
    en: "Are you sure you want to delete {name} and {count} more items?",
  },
  DELETE_TARGET_VARIABLE_SUCCEED: {
    ko: "변수를 삭제했습니다.",
    en: "Variable has been deleted.",
  },
  DELETE_TARGET_VARIABLE_FAIL: {
    ko: "변수 삭제에 실패했습니다.",
    en: "Failed to delete variable.",
  },

  CREATE_TARGET_VARIABLE_SUCCEED: {
    ko: "변수를 추가했습니다.",
    en: "Variable(s) has(have) been added.",
  },
  CREATE_TARGET_VARIABLE_FAIL: {
    ko: "변수 추가에 실패했습니다.",
    en: "Failed to add Variable(s).",
  },

  PLACEHOLDER_DOMAIN_NAME: { ko: "Domain 이름 입력 또는 선택", en: "Select or Enter the Domain name" },
  PLACEHOLDER_DOMAIN_LABEL: { ko: "Domain 레이블 입력", en: "Enter the domain label" },
  PLACEHOLDER_STRUCTURE: { ko: "Structure 입력", en: "Enter the structure" },
  PLACEHOLDER_DATASET_NAME: { ko: "Dataset 이름 입력", en: "Enter the Dataset name" },
  PLACEHOLDER_DATASET_LABEL: { ko: "Dataset 레이블 입력", en: "Enter the Dataset label" },

  DATASET_REMOVE_RESTRICT_DESCRIPTION: {
    ko: "결과 파일 생성 완료",
    en: "Output file has been created",
  },
  DATASET_REMOVE_RESTRICT_CANDIDATE_IN_USE: {
    ko: "이 Candidate를 사용하는 Target Dataset이 있어 삭제할 수 없습니다.",
    en: "Cannot delete because a target dataset is using this candidate.",
  },
  DATASET_REMOVE_RESTRICT_PREDECESSOR_IN_USE: {
    ko: "Predecessor 원본으로 사용 중이라 삭제할 수 없습니다.",
    en: "Cannot delete because it is used as a predecessor source.",
  },

  EXPORT_TARGET_DATASETS_TITLE: {
    ko: "내려받을 대상 데이터 세트 선택",
    en: "Select Target Dataset for Export",
  },
  EXPORT_TARGET_DATASETS_DESCRIPTION: {
    ko: "CSV형식의 빈 데이터 파일로 내려받을 대상 데이터 세트를 선택하세요.",
    en: "Select the target dataset to download an empty data file in CSV format.",
  },

  CUSTOM_DOMAIN_NAME_RULE_EXCEEED: {
    ko: "영대문자 2자리이며, X, Y, Z로 시작해야 합니다.",
    en: "The first letter does not start with X, Y, or Z.",
  },
  DATASET_NAME_RULE_EXCEEED: {
    ko: "도메인명으로 시작하고, 영대문자와 숫자로 구성되며, 숫자가 포함될 경우 마지막 자리에서만 허용됩니다.",
    en: "The dataset name must start with a domain name and can only contain uppercase letters and numbers, with numbers allowed only at the end.",
  },
  DATASET_FIELD_MAX_LENGTH_EXCEEDED: {
    ko: "최대 {maxLength}자까지 입력 가능합니다.",
    en: "Maximum {maxLength} characters.",
  },
  SELECTION_BAR_SELECT_ALL_BUTTON: {
    ko: "전체 선택",
    en: "Select All",
  },
  SELECTION_BAR_UNCHECK_BUTTON: {
    ko: "선택 항목 해제",
    en: "Uncheck",
  },
  TARGET_VARIABLES_TITLE: {
    ko: "대상 변수",
    en: "Target Variables",
  },
  INDEXED_VARIABLE_CREATE_DIALOG_TITLE: {
    ko: "인덱싱 변수 생성",
    en: "Generate Indexed Variables",
  },
  INDEXED_VARIABLE_RESET_DIALOG_TITLE: {
    ko: "인덱싱 변수 재설정",
    en: "Regenerate Indexed Variables",
  },
  INDEXED_VARIABLE_CREATE_DIALOG_DESCRIPTION: {
    ko: "생성할 변수의 최대 인덱스 번호를 입력하세요.\n(예: 3 입력 시 {name}1, {name}2, {name}3 생성)",
    en: "Enter the maximum index number for the variables to generate.\n(e.g. Entering 3 generates {name}1, {name}2, {name}3)",
  },
  INDEXED_VARIABLE_RESET_DIALOG_DESCRIPTION: {
    ko: "기존 인덱싱 변수가 모두 삭제되고 새로운 max값 기준으로 재생성됩니다.\n기존 매핑 정보도 함께 초기화됩니다.",
    en: "All existing indexed variables will be deleted and regenerated based on the new max value.\nExisting mapping information will also be reset.",
  },
  INDEXED_VARIABLE_MAX_INDEX_LABEL: {
    ko: "최대 인덱스 (n)",
    en: "Max Index (n)",
  },
  INDEXED_VARIABLE_MAX_INDEX_PLACEHOLDER: {
    ko: "정수를 입력하세요.",
    en: "Enter an integer.",
  },
  INDEXED_VARIABLE_GENERATE_BUTTON: {
    ko: "생성",
    en: "Generate",
  },
  INDEXED_VARIABLE_REGENERATE_BUTTON: {
    ko: "재생성",
    en: "Regenerate",
  },
  INDEXED_VARIABLE_UPSERT_SUCCEED: {
    ko: "인덱싱 변수가 생성되었습니다.",
    en: "Indexed variables have been generated.",
  },
  INDEXED_VARIABLE_UPSERT_FAIL: {
    ko: "인덱싱 변수 생성에 실패하였습니다.",
    en: "Failed to generate indexed variables.",
  },
  INDEXED_VARIABLE_RESET_SUCCEED: {
    ko: "인덱싱 변수가 재설정되었습니다.",
    en: "Indexed variables have been regenerated.",
  },
  INDEXED_VARIABLE_RESET_FAIL: {
    ko: "인덱싱 변수 재설정에 실패하였습니다.",
    en: "Failed to regenerate indexed variables.",
  },
  INDEXED_VARIABLE_POSITIVE_INTEGER_VALIDATION: {
    ko: "1 이상의 정수를 입력해주세요.",
    en: "Please enter a positive integer (1 or more).",
  },
  INDEXED_VARIABLE_MAX_EXCEEDED_VALIDATION: {
    ko: "최대 10까지 입력 가능합니다.",
    en: "Maximum value is 10.",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_DATASET_LANG);
